
import store from '../config/store'

export default {
  components: {
    'advisor': () => import(/* webpackChunkName: "modals" */ './modals/Advisor.vue'),
    'exchange-rate': () => import(/* webpackChunkName: "modals" */ './modals/ExchangeRate.vue'),
    'check-password': () => import(/* webpackChunkName: "modals" */ './modals/CheckPassword.vue'),
    'stop-cheque': () => import(/* webpackChunkName: "modals" */ './modals/StopCheque.vue'),
    'join-document': () => import(/* webpackChunkName: "modals" */ './modals/JoinDocument.vue'),
    'join-transfer-documents': () => import(/* webpackChunkName: "modals" */ './modals/JoinTransferDocuments.vue'),
    'delete': () => import(/* webpackChunkName: "modals" */ './modals/Delete.vue'),
    'customer-infos': () => import(/* webpackChunkName: "modals" */ './modals/CustomerInfos.vue'),
    'send-message': () => import(/* webpackChunkName: "modals" */ './modals/SendMessage.vue'),
    'create-beneficiary-list': () => import(/* webpackChunkName: "modals" */ './modals/CreateBeneficiaryList.vue'),
    'wait': () => import(/* webpackChunkName: "modals" */ './modals/Wait.vue'),
    'reject-reason': () => import(/* webpackChunkName: "modals" */ './modals/RejectReason.vue'),
  },
  data: () => ({
    store
  }),

  mounted () {
  },

  methods: {
    onClickBackground () {
      if (!(store.modal.blockLeaveBackground && store.loading)) {
        store.modal.active = false
      }
    },
    onCloseModal () {
      store.modal.active = false
    }
  }
}
